export const inputsException = (col: any, inputForm: any) => {
  // username required solo per "Accesso tramite credenziali applicative"
  if (col?.accessorKey === "username") {
    col.required =
      inputForm["external_employee_flag"] === "true" ||
      inputForm["external_employee_flag"] === true;
  }
  return col;
};
